import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import About from "@/components/About";
import WhyFulltrui from "@/components/WhyFulltrui";
import HowItWorks from "@/components/HowItWorks";
import Footer from "@/components/Footer";
import { AnimatedSection } from "@/components/AnimatedSection";

const Index = () => {
  return (
    <main className="min-h-screen">
      <Navigation />
      <Hero />
      
      <AnimatedSection delay={0.3}>
        <About />
      </AnimatedSection>
      
      <AnimatedSection delay={0.3}>
        <WhyFulltrui />
      </AnimatedSection>
      
      <AnimatedSection delay={0.3}>
        <HowItWorks />
      </AnimatedSection>
      
      <Footer />
    </main>
  );
};

export default Index;
